<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>

      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <!-- <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      /> -->
      
    </CSidebarBrand>
      <b v-if="!isProduction" class="text-center py-3">{{getHostName()}}</b>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleSidebar')"
    />
    
  </CSidebar>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { AppSidebarNav } from "./AppSidebarNav";
import { logoNegative } from "@/assets/brand/logo-negative";
import { sygnet } from "@/assets/brand/sygnet";
export default {
  name: "AppSidebar",
  components: {
    AppSidebarNav,
  },
  data() {
    return {
      isProduction: true
    }
  },
  setup() {
    const store = useStore();
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    };
  },
  methods: {
    getHostName: function() {

      let hostname = window.location.hostname;
      if (hostname == 'testapp.byttgass.no') {
        this.isProduction = false
        return 'TEST SERVER'
      } else if (hostname == 'localhost') {
        this.isProduction = false
        return 'LOCALHOST'
      } else {
        this.isProduction = true
      }
      
    }
  },
  mounted() {
    this.getHostName()
  }
};
</script>
